/**
 * Returns a trimmed versions of the input and removes all duplicated whitespaces
 *
 * @param input -
 */
export function normalize(input?: string): string {
  return input?.trim().replace(/\s+/g, ' ') ?? '';
}
